/**
 * displays selected filter into frontend element
 */
export default class filterSelector {
    constructor() {
        this.appendElementsToContainer();
    }

    /**
     * adds selected filters to frontend container
     * with click eventlistener to remove them
     */
    appendElementsToContainer() {
        var selectedFilter = this.getAllSelectedFilter();
        var container = document.querySelector('#checked-filter-tags');

        selectedFilter.forEach(filter => {
            /* clone elem */
            var elem = this.cloneElement(filter.parentElement);

            /* add click eventlistener to elem */
            elem.addEventListener('click', (event) => {
                /* get element value + inputs */
                let value = event.target.getAttribute('value');
                let checkbox = document.querySelector('input[value="' + value + '"]');
                /* check if value and checkbox are set */
                if (value && checkbox) {
                    /* uncheck checkbox */
                    checkbox.checked = false;
                    /* remove elem */
                    elem.remove();
                    /* submit form */
                    this.sendFilterForm();
                }
            });
            /* append elem to container */
            container.appendChild(elem);
        });

        if (selectedFilter.length > 0) {
            this.createResetButton(container);
        }
    }

    /**
     * gets all checkboxes from the frontend and adds them to the checkbox array
     * @returns {Array} checkboxes
     */
    getAllCheckboxes() {
        var checkboxes = [];
        var allCheckboxes = document.querySelectorAll('.filter input[type="checkbox"]');

        allCheckboxes.forEach(checkbox => {
            checkboxes.push(checkbox);
        });

        return checkboxes;
    }

    /**
     * compares the selected checkboxes with the checkboxes from the frontend and returns the selected checkboxes
     * @returns {Array} selectedFilter
     */
    getAllSelectedFilter() {
        var selectedFilter = [];
        var allCheckboxes = this.getAllCheckboxes();

        allCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
                selectedFilter.push(checkbox);
            }
        });

        return selectedFilter;
    }

    /* creates a reset-button and appends it to the container */
    createResetButton(container) {
        var resetButton = document.createElement('button');
        resetButton.innerHTML = 'Zurücksetzen';
        resetButton.classList.add('btn');
        resetButton.classList.add('btn-reset');
        resetButton.addEventListener('click', () => {
            this.resetAllCheckboxes();
            this.clearContainer();
            this.sendFilterForm();
        });
        container.appendChild(resetButton);
    }

    /* resets all checkboxes to unchecked */
    resetAllCheckboxes() {
        var allCheckboxes = this.getAllCheckboxes();

        allCheckboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
    }

    /* submits the filter form */
    sendFilterForm() {
        var form = document.querySelector('.filter > form');
        form.submit();
    }

    /* clears the container */
    clearContainer() {
        var container = document.querySelector('#checked-filter-tags');
        container.innerHTML = '<img src="/fileadmin/_template/Images/loading.gif" width="32" height="32" alt="">';
    }

    /* clones an element */
    cloneElement(element) {
        var clone = element.cloneNode(true);
        return clone;
    }
}
